<template>
<div class="chapter">
<div class="inner_page">
<p class="blockquotex"><a id="page_2"></a>Geography provides strategy with an underlying continuity.</p>
<p class="attributex">HEW STRACHAN<a id="rch1en1"></a><sup><span href="#/xhtml/notes#ch1en1" title="Link target outside of Sample">1</span></sup></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontm01.vue?fb93b68a